import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getAuth, connectAuthEmulator, sendEmailVerification, sendPasswordResetEmail } from "firebase/auth";

const firebaseConfig = JSON.parse(atob(process.env.REACT_APP_FIREBASE_CONFIG));

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// initialize authentication
const auth = getAuth(app);

// initialize messaging
const messaging = getMessaging(app);

if (process.env.NODE_ENV === 'development') {
    connectAuthEmulator(auth, process.env.REACT_APP_EMULATOR_HOST, { disableWarnings: false });
}

export { auth, messaging };

export const sendVerificationEmail = async (user) => {
    if (user) {
        sendEmailVerification(user)
            .then(() => {
                return true;
            })
            .catch((error) => {
                return { error: error.message };
            });
    } else {
        return { error: 'User not found' };
    }
};

export const sendPasswordReset = async (email) => {
    await sendPasswordResetEmail(auth, email)
        .then(() => {
            return true;
        })
        .catch((error) => {
            return { error: error.message };
        });
};

export async function askForPermissionAndGetToken() {
    if (!("Notification" in window)) return null;

    const permission = await Notification.requestPermission();

    if (permission !== "granted") return null;

    try {
        const token = await getToken(messaging, {
            vapidKey: process.env.REACT_APP_FCM_VAPID_KEY
        });

        return token || null;
    } catch (e) {
        console.error("getToken failed", e);

        return null;
    }
}

export function onMessageListener(callback) {
    return onMessage(messaging, callback);
}
